import '../assets/css/product-card.css';

import { Link } from 'react-router-dom';
import { Price , W_Time} from '../../assets/icones/icones';
import React, {Fragment} from "react";
import {FormatNumberByhkh, Get_Weight_txt_bk} from "../../clientconfigwebapp";

const ProductCard = (props) => {


    let link_post_get="/" + props.link_to;
    link_post_get=link_post_get.replaceAll("//","")



    return (
        <Fragment>
            <style jsx>{`

                /* card_product START  */
                .card_products_box {
                    padding-top: 0px !important;
                    box-sizing: border-box;
                    background: #FFFFFF;
                    border: 1px solid #F3F4F6;
                    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
                    border-radius: 8px;
                    flex: none;
                    order: 3;
                    flex-grow: 0;
                }

                .img-card_products_box {
                    width: 100%;
                    height: 160px;
                    object-fit: cover;
                    cursor: pointer;
                    transition: all .3s;
                    border-top-right-radius: 10px;
                    border-top-left-radius: 10px;
                    position: relative;
                }

                .card_products_box_title {
                    width: 100%;
                    font-size: 15px !important;
                    padding: 10px;
                    font-family: 'iran';
                    color: black;
                    font-weight: bold;
                    padding-top: 14px !important;
                    display: block !important;
                    padding-bottom: 10px !important;
                }

                .card-product-box-img {
                    position: relative;
                }


             

                .bottom-price-card-product {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    border-top: 1px solid #D9D9D9;
                    padding-top: 14px;
                    padding-bottom: 14px;
                    padding-right: 10px;
                    padding-left: 10px;
                }

           .products_card_icons{
               display: flex; flex-direction: row; padding-right: 10px; font-size: 13px; margin-bottom: 6px;
           }

                .products_card_icons span {
                    padding-right: 8px;
                    color: #646464;
                    font-size: 13px;
                    font-family: 'iran';
                }



                .products_card_icon_Authentication{
                    height: 26px;
                    display: flex; flex-direction: row; padding-right: 10px; font-size: 13px;
                    margin-bottom: 11px !important;
                }

                .products_card_icon_Authentication span {
                    background-color: #c5eaf5;
                    font-size: 13px;
                    font-family: 'iran';
                    color: #32b4dc !important;
                    padding: 3px;
                    border-radius: 10px;
                    margin-right: 3px;
                    padding-right: 11px !important;
                    display: block;
                    padding-left: 11px !important;
                }

                span.widget-bottom-card-product {
                    font-size: 13px;
                }
                
                @media only screen and (min-width: 1023px)   and (max-device-width: 1289px) {
                    .img-card_products_box {
                        height: 110px !important;
                    }

                }
                /* card_product START  */

            

            `}</style>


            <div className='card_products_box'>
                <div className="card-product-box-img">
                    <a href={link_post_get}>
                        <img className={"img-card_products_box"} src={props.data_full_curent_item.image_src_b}   alt={props.data_full_curent_item.title_post} />

                        { props.data_full_curent_item && props.data_full_curent_item.special_seller && props.data_full_curent_item.special_seller == "yes" &&
                            <div className={"absolute top-[5px] left-[6px] bg-[#FF9828] p-[5px] rounded-[10px] min-w-[112px] text-center"}>
                                <span className={"text-[white] text-[12px]"}>فروشنده ویژه</span>
                            </div>

                        }
                    </a>
                </div>
                <div>
                    <a href={link_post_get}
                       className={"card_products_box_title"}>{props.data_full_curent_item.title_post}</a>
                </div>

                <div className={"products_card_icons"}>
                    <svg width={14} height={14} viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.54962 0.642822C2.09593 0.642822 0.0996094 2.54408 0.0996094 4.88093C0.0996094 5.58245 0.283772 6.27801 0.63387 6.89495L4.30627 13.2205C4.35516 13.3049 4.44832 13.3571 4.54962 13.3571C4.65092 13.3571 4.74408 13.3049 4.79297 13.2205L8.46672 6.89287C8.81547 6.27801 8.99963 5.58242 8.99963 4.8809C8.99963 2.54408 7.00331 0.642822 4.54962 0.642822ZM4.54962 6.99997C3.32277 6.99997 2.32463 6.04935 2.32463 4.88093C2.32463 3.7125 3.32277 2.76189 4.54962 2.76189C5.77646 2.76189 6.77461 3.7125 6.77461 4.88093C6.77461 6.04935 5.77646 6.99997 4.54962 6.99997Z"
                            fill="#01A3D4"/>
                    </svg>
                    <span>{props.data_full_curent_item.state_text} ، {props.data_full_curent_item.city_text}</span>
                </div>


                <div className={"products_card_icons"}>
                    <svg width={14} height={14} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.625 0.703125L10.5 3.14062V9.23438L5.625 11.666L0.75 9.23438V3.14062L5.625 0.703125ZM9.28711 3.375L5.625 1.54688L4.21289 2.25L7.85156 4.08984L9.28711 3.375ZM5.625 5.20312L7.01953 4.51172L3.375 2.67188L1.96289 3.375L5.625 5.20312ZM1.5 3.98438V8.76562L5.25 10.6406V5.85938L1.5 3.98438ZM6 10.6406L9.75 8.76562V3.98438L6 5.85938V10.6406Z"
                            fill="#01A3D4"/>
                    </svg>
                    <span>{Get_Weight_txt_bk(props.data_full_curent_item.order_amount)} </span>
                </div>


                { props.data_full_curent_item && props.data_full_curent_item.user_authentication && props.data_full_curent_item.user_authentication == "yes"  ? (
                    <div className={"products_card_icon_Authentication "}>
                        <svg width={14} height={14} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.41667 9.70841L3.25 7.54175L4.01375 6.778L5.41667 8.1755L8.98625 4.60591L9.75 5.37508M6.5 1.04175L1.625 3.20841V6.45841C1.625 9.46466 3.705 12.2759 6.5 12.9584C9.295 12.2759 11.375 9.46466 11.375 6.45841V3.20841L6.5 1.04175Z"
                                fill="#01A3D4"/>
                        </svg>
                        <span>احراز هویت شده</span>
                    </div>
                ):(
                    <div className={"products_card_icon_Authentication "}></div>
                )
                }


                <div className={"bottom-price-card-product"}>
                    <span className={"widget-bottom-card-product"}>هر کیلوگرم</span>
                    <div>
                        {FormatNumberByhkh(String(props.data_full_curent_item.price), ".", ",", "no")}
                        <span style={{"paddingRight": "3px", "fontSize": "11px", "color": "#767676"}}>تومان</span>
                    </div>

                </div>

            </div>
        </Fragment>
    );
}

export default ProductCard;